module.exports = __webpack_public_path__ + "static/media/tsb.7c14ea23.png";